import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { TranslationService } from "../translation.service";

export const loadTranslationResolver =
  (paths: string | string[]): ResolveFn<Set<string>> =>
  (_route, _state) =>
    inject(TranslationService).load(paths);
